/* eslint-disable */
import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import css from './PosterArrowButton.scss';

const classes = {
	root: css.posterArrowButton,
	isDisabled: css.isDisabled,
};

const propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	disabled: PropTypes.bool,
};

const defaultProps = {
	className: '',
	classes,
	disabled: false,
};

export function PosterArrowButton({ className, classes, disabled, ...props }) {
	return (
		<svg
			className={cls(classes.root, className, {
				[classes.isDisabled]: disabled,
			})}
			{...props}
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24.5 20.731'>
			
			<path
				style={{ fill: 'white', fillRule: 'evenodd' }}
				d='M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z'
			/>
		</svg>
	);
}

PosterArrowButton.displayName = 'PosterArrowButton';
PosterArrowButton.propTypes = propTypes;
PosterArrowButton.defaultProps = defaultProps;
export default PosterArrowButton;
